import React, {PureComponent} from "react"
import styled from "styled-components"

import Button from "@irati/ui/src/Button"
import {FormattedMessage} from "@irati/utils/lang"
import ErrorText from "@irati/ui/src/ErrorText"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"

const StyledButton = styled(Button)`
  margin-top: ${({theme}) => theme.spacing.one};
`

interface Props {
  apolloState: ApolloState
  disabled: boolean
  id: string
  message: string
  onClick(): void
}

class RewardButton extends PureComponent<Props> {
  render() {
    const {apolloState, disabled, id, message, onClick} = this.props

    return (
      <>
        {apolloState.error && (
          <ErrorText>
            <FormattedMessage id={apolloState.errorMsg} />
          </ErrorText>
        )}
        <StyledButton apolloState={apolloState} disabled={disabled} id={id} full large onClick={onClick} primary>
          <FormattedMessage id={message} />
        </StyledButton>
      </>
    )
  }
}

export default RewardButton
